const resources = {
    applyOrderDiscount: '/api/orderdiscount/apply',
    removeOrderDiscount: '/api/orderdiscount/remove',
    downloadImage: '/api/images/download',
    initiateFacebookPayment: '/facebookpayment/initiate',
    executeFacebookPayment: '/facebookpayment/execute',
    cancelFacebookPayment: '/facebookpayment/cancel',
    deliver: '/order/deliver',
    paypal: '/paypal/index',
    generateOrnaments: '/coatofarms/generateornaments',
    coatofarmDownload: '/download',
    coatofarmDownloadEmail: '/download/SendEmailDownload',
    changeEmailAjax: '/account/ChangeEmailAjax',
    saveActivity: '/api/log/activity',
    logKPI: '/api/log/kpi',
    log: '/api/log/capture'
};

export const api = {
    resources: resources
};